import React, { useRef } from 'react';
import CarbonFootprint from './icons/sustainability/CarbonFootprint';
import Circularity from './icons/sustainability/Circularity';
import LowWater from './icons/sustainability/LowWater';
import NaturalMaterials from './icons/sustainability/NaturalMaterials';
import Packaging from './icons/sustainability/Packaging';
import People from './icons/sustainability/People';
import Recycle from './icons/sustainability/Recycle';
import Sun from './icons/sustainability/Sun';
import ZeroLowWaste from './icons/sustainability/ZeroLowWaste';

import BlockContent from '@sanity/block-content-to-react';
import richText from '../serializers/richText';
import classNames from 'classnames';
import useIntersection from 'buena-suerte/lib/hooks/useIntersection';

export default ({ title, list = [], description, image }) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef);
  return (
    <section
      ref={intersectionRef}
      className={classNames(
        'p1 pt5 pb5 p5--md p10--lg reveal bt--dark-brown--lg',
        {
          revealed: isIntersected,
        }
      )}
    >
      <div className="sustainability b--dark-brown">
        <p className="serif--md serif--lg--lg p2 bb--dark-brown">{title}</p>
        <div className="df fdc fdr--lg">
          <div className="bb--dark-brown br--dark-brown--lg sans--sm sans--md--lg p2 rich-text sustainability__description">
            <BlockContent blocks={description} serializers={richText} />
          </div>
          <ul className="sustainability__list">
            {list &&
              list.map((item, index) => {
                let icon;

                switch (item.icon) {
                  case 'carbon-footprint':
                    icon = (
                      <CarbonFootprint className="sustainability__icon pr2" />
                    );
                    break;
                  case 'circularity':
                    icon = <Circularity className="sustainability__icon pr2" />;
                    break;
                  case 'low-water':
                    icon = <LowWater className="sustainability__icon pr2" />;
                    break;
                  case 'natural-materials':
                    icon = (
                      <NaturalMaterials className="sustainability__icon pr2" />
                    );
                    break;
                  case 'packaging':
                    icon = <Packaging className="sustainability__icon pr2" />;
                    break;
                  case 'people':
                    icon = <People className="sustainability__icon pr2" />;
                    break;
                  case 'recycle':
                    icon = <Recycle className="sustainability__icon pr2" />;
                    break;
                  case 'sun':
                    icon = <Sun className="sustainability__icon pr2" />;
                    break;
                  case 'low-waste':
                    icon = (
                      <ZeroLowWaste className="sustainability__icon pr2" />
                    );
                    break;
                  default:
                    break;
                }
                return (
                  <li
                    key={item._key}
                    className={classNames('sustainability__list-item p2', {
                      'bb--dark-brown': index < list.length - 1,
                    })}
                  >
                    <p className="serif--sm serif--md--lg df aic">
                      {icon}
                      {item.title}
                    </p>
                    <div className="rich-text sans--sm sans--md--lg  pt1 pt2--lg">
                      <BlockContent
                        blocks={item.definition}
                        serializers={richText}
                      />
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </section>
  );
};
